import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Switch = styled.label`
  display: block;
  position:relative;
  /* 테마 스위치 */
  width: 50px;
  height: 26px;

  & input:checked + & .slider {
      background: linear-gradient(90deg, var(--accent-color), var(--btn-bg-color));
  }

  & input:checked + & .slider::before {
      content: '🌙';
      transform: translateX(20px);
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, var(--btn-bg-color), var(--accent-color));
  border-radius: 34px;
  transition: background 0.4s;

  &::before {
      position: absolute;
      content: '☀️';
      font-size: 16px;
      line-height: 25px;
      text-align: center;
      height: 25px;
      width: 25px;
      left: 3px;
      bottom: 0;
      color: var(--btn-text-color);
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      transition: transform 0.4s, content 0.4s;
  }
`;

const ThemeSwitch: React.FC= () => {
  const [isDark, setIsDark] = useState<boolean>(false);

  useEffect(() => {
    const currentTheme = localStorage.getItem('theme');
    if (currentTheme === 'dark') setIsDark(true);
  }, []);

  const handleThemeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const targetTheme = e.target.checked ? 'dark' : 'light';
    setIsDark(e.target.checked);
    document.documentElement.setAttribute('data-theme', targetTheme);
    localStorage.setItem('theme', targetTheme);
  };

  return (
    <Switch>
      <input type="checkbox" id="theme-toggle" checked={isDark} onChange={handleThemeChange} />
      <Slider className="slider"></Slider>
    </Switch>
  );
};

export default ThemeSwitch;